import React, {useRef, useState} from "react";
import {ArrowDownIcon} from "../utils/image";
import {useFetch} from "../services/useFetch";
import {API} from "../services/api";
import {useClickOutside} from "../services/useClickOutside";

const SearchSelectComponent = (props) => {
    const {item, onChangeSelect} = props
    const [isShowModal, setIsShowModal] = useState(false)
    const searchValue = useRef()
    const [list, setList] = useState([])
    const {fetching: searchVoucher} = useFetch(API.SEARCH_VOUCHER, {}, {isFetching: false})

    const showHideModal = () => {
        setIsShowModal(!isShowModal)
    }

    const searchListOption = (event) => {
        const keyword = event.target.value
        let params = {
            code: keyword
        }
        searchVoucher(params)
            .then(response => {
                setList(response.data)
                setIsShowModal(true)
            })
    }

    const onChangeData = (dataItem) => {
        !!onChangeSelect && onChangeSelect(dataItem)
        showHideModal()
        searchValue.current.value = dataItem.code
    }

    useClickOutside(`search-select-component-${item.key}`, isShowModal, setIsShowModal)

    return (
        <div id={`search-select-component-${item.key}`} className={"relative col font-regular text-forged-steel"}>
            <div
                className={`row items-center px-2 h-9 border border-placebo bg-white ${isShowModal ? 'rounded-t-lg' : 'rounded-lg'}`}>
                <input type={"text"} name={item.key} id={item.key}
                       className={"border-0 outline-0 px-3 w-full disabled:bg-white placeholder:italic"}
                       ref={searchValue} onChange={searchListOption} placeholder={item?.placeholder}/>
                <img className={"w-2.5 h-5"} src={ArrowDownIcon} alt={'arrowDown'}/>
            </div>
            <div className={`${isShowModal ? 'block' : 'hidden'} absolute top-8 w-full z-10`}>
                <div
                    className={"col bg-white border border-placebo mb-5 max-h-32 overflow-scroll"}>
                    {list?.length > 0 ? list?.map((l, index) => (
                        <div key={index}
                             className={"row p-2 cursor-pointer hover:bg-apple-flower hover:text-monstera hover:font-Montserrat-Bold"}
                             onClick={() => onChangeData(l)}>
                            <p>{l.code}</p>
                        </div>
                    )) : <p className={"p-3 text-center"}>Not Found</p>}
                </div>
            </div>
        </div>
    )
}

export default SearchSelectComponent
